<form class="filter" #formElement [formGroup]="form">
    <mat-form-field class="medium-width">
        <mat-label>Nombre</mat-label>
        <input type="text" matInput formControlName="Name">
    </mat-form-field>
</form>